/* eslint-disable prefer-template */
import styled, { css } from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

export const Container = styled.section`
    position: relative;
    max-height: ${({ initialMaxHeight }) => `${initialMaxHeight || 500}px`};
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
    will-change: contents;
    ${({ expanded, maxHeight }) =>
        expanded &&
        css`
            max-height: ${maxHeight ? maxHeight + 'px' : 'max-content'};
        `};
`;

export const GWrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Gradient = styled.div`
    position: absolute;
    bottom: 0;
    height: 0;
    width: 100%;
    padding-bottom: 20%;
    background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 50%, #fff 100%);

    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding-bottom: 30%;
    `};
`;

export const Button = styled(ButtonV2)`
    margin: 16px;
`;
